import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFela } from 'react-fela';

import { PageWrapper } from 'modules/layout';
import ImageMapsPage from '../../containers/ImageMapsPage';

import rule from './MapsPage.rule';

const MapsPage = () => {
    const { css } = useFela();
    return (
        <PageWrapper
            header={
                <Fragment>
                    <FormattedMessage id="maps.page.title" />
                </Fragment>
            }
        >
            <div className={css(rule)}>
                <ImageMapsPage />
            </div>
        </PageWrapper>
    );
};

export default MapsPage;
